import { fetchSubmissionHookLogs } from "@/api/forms";
import { formatApiQueryError } from "@/lib/http/formatQueryError";
import type { HookLogDto } from "@/types/hookLog";
import { useAsyncResource } from "./useAsyncResource";

interface UseSubmissionHookLogsQueryOptions {
  formId: number;
  submissionId: number | null;
  enabled?: boolean;
}

interface UseSubmissionHookLogsQueryResult {
  logs: HookLogDto[];
  isLoading: boolean;
  error: string | null;
  reload: () => void;
}

export function useSubmissionHookLogsQuery({
  formId,
  submissionId,
  enabled = true,
}: UseSubmissionHookLogsQueryOptions): UseSubmissionHookLogsQueryResult {
  const { data, isLoading, error, reload } = useAsyncResource({
    enabled: enabled && submissionId != null,
    deps: [formId, submissionId],
    fetch: () => fetchSubmissionHookLogs(formId, submissionId!),
    formatError: (err) =>
      formatApiQueryError(err, "Не удалось загрузить журнал вебхуков", {
        forbidden: "Нет доступа к журналу вебхуков.",
        statusPrefix: "Не удалось загрузить журнал вебхуков",
      }),
    initialLoading: false,
    clearOnError: true,
  });

  return {
    logs: data ?? [],
    isLoading,
    error,
    reload,
  };
}
